import { TextWithMarking } from '@mewa/types';

// Regex to extract the different link parts in the following format:
//
//     Text before link [link text] text after link.
//
const TEXT_WITH_MARKING_REGEX = /(?<before>.*)(?<link>\[.*\])(?<after>.*)/;

export const extractTextMarking = (text: string): TextWithMarking => {
  const regexRes = TEXT_WITH_MARKING_REGEX.exec(text);

  if (!regexRes || !regexRes.groups) {
    return {
      beforeMarking: text,
      marking: '',
      afterMarking: '',
    };
  }

  const res = {
    beforeMarking: regexRes.groups['before'],
    marking: regexRes.groups['link'],
    afterMarking: regexRes.groups['after'],
  };

  // remove `[` and `]` from link annotation
  res.marking = res.marking.substring(1, res.marking.length - 1);

  return res;
};
